import { render, staticRenderFns } from "./NewTransfer.vue?vue&type=template&id=2db8f546"
import script from "./NewTransfer.vue?vue&type=script&lang=js"
export * from "./NewTransfer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports